module.exports = __webpack_public_path__ + "img/组 255.6cc8ce1e.png";